import axios from "axios";

export const deleteArticle = async (id: number): Promise<boolean> => {
    try {
        const token = localStorage.getItem("token"); // token'ı buradan al
        if (!token) {
            console.error("Admin token gerekli");
            return false;
        }

        const headers = { Authorization: `Bearer ${token}` };
        await axios.delete(
            `https://portfoliom-backend.vercel.app/articles/${id}`,
            { headers }
        );

        return true;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Axios hatası:", error.response?.data || error.message);
        } else {
            console.error("Bilinmeyen hata:", error);
        }
        return false;
    }
};
